webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(119);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(118);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(94);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SCORE_MAX = undefined;
	
	var _stringify = __webpack_require__(18);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(50);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCORE_MAX = exports.SCORE_MAX = 200;
	
	var Game = function () {
	  function Game(name, players, rounds, scores) {
	    var winnerID = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	    (0, _classCallCheck3.default)(this, Game);
	
	    this.name = name;
	    this.players = players || [];
	    this.rounds = rounds || [];
	    this.scores = scores || [];
	    this.winnerID = winnerID;
	    this.yanivID = null;
	  }
	
	  (0, _createClass3.default)(Game, [{
	    key: 'addRound',
	    value: function addRound(round) {
	      var _this = this;
	
	      var score = void 0,
	          gameOver = void 0,
	          hasCounter = this.roundHasCounter(round, this.yanivID),
	          num = this.rounds.length;
	
	      var applyDouche = function applyDouche() {
	        if (score.total % 50 === 0) {
	          score.douche = true;
	          score.total -= 50;
	        }
	      };
	
	      this.scores[num] = [];
	      this.initScores();
	
	      round.forEach(function (points, index) {
	        score = _this.scores[num][index];
	        if (index === _this.yanivID) {
	          score.yaniv = true;
	          if (hasCounter) {
	            score.contre = true;
	            score.total += points + 30;
	            if (points > 0) applyDouche();
	          }
	        } else {
	          score.total += points;
	          if (points > 0) applyDouche();
	        }
	
	        if (score.total >= SCORE_MAX) gameOver = true;
	      });
	
	      this.rounds.push(round);
	      if (gameOver) {
	        var minusScore = SCORE_MAX;
	        this.scores[num].forEach(function (score, index) {
	          if (score.total < minusScore) {
	            minusScore = score.total;
	            _this.winnerID = index;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'roundHasCounter',
	    value: function roundHasCounter(round, playerIDYaniv) {
	      var yanivScore = round[playerIDYaniv],
	          otherScores = [].concat((0, _toConsumableArray3.default)(round.slice(0, playerIDYaniv)), (0, _toConsumableArray3.default)(round.slice(playerIDYaniv + 1)));
	      return Math.min.apply(Math, (0, _toConsumableArray3.default)(otherScores)) <= yanivScore;
	    }
	  }, {
	    key: 'removeLastRound',
	    value: function removeLastRound() {
	      this.rounds = this.rounds.slice(0, -1);
	      this.scores = this.scores.slice(0, -1);
	      this.winnerID = -1;
	    }
	  }, {
	    key: 'setPlayers',
	    value: function setPlayers(players) {
	      this.players = players;
	    }
	  }, {
	    key: 'setYanivID',
	    value: function setYanivID(index) {
	      this.yanivID = index;
	    }
	  }, {
	    key: 'initScores',
	    value: function initScores() {
	      var score = this.scores[this.scores.length - 1],
	          previous = this.scores.length ? this.scores[this.scores.length - 2] : null;
	      this.players.map(function (player, id) {
	        score.push({
	          'total': previous ? previous[id].total : 0,
	          'douche': false,
	          'contre': false,
	          'yaniv': false
	        });
	      });
	    }
	  }, {
	    key: 'hasPlayers',
	    value: function hasPlayers() {
	      return this.players && this.players.length;
	    }
	  }]);
	  return Game;
	}();
	
	var GamesStore = function () {
	  function GamesStore() {
	    (0, _classCallCheck3.default)(this, GamesStore);
	
	    this.state = {
	      games: this.getLocalStorage(),
	      currentGame: null
	    };
	  }
	
	  (0, _createClass3.default)(GamesStore, [{
	    key: 'addGame',
	    value: function addGame(name) {
	      var gameID = this.state.games.length,
	          game = new Game(name);
	      this.state.games.push(game);
	      return gameID;
	    }
	  }, {
	    key: 'removeGame',
	    value: function removeGame(gameID) {
	      this.state.games.splice(gameID, 1);
	    }
	  }, {
	    key: 'getGame',
	    value: function getGame(gameID) {
	      return this.state.games[gameID];
	    }
	  }, {
	    key: 'setCurrentGame',
	    value: function setCurrentGame(gameID) {
	      this.state.currentGame = this.state.games[gameID];
	    }
	  }, {
	    key: 'getLocalStorage',
	    value: function getLocalStorage() {
	      var storedGames = window.localStorage['yaniv-score-games'],
	          gamesData = storedGames ? JSON.parse(storedGames) : [],
	          games = [];
	      gamesData.map(function (data) {
	        games.push(new Game(data.name, data.players, data.rounds, data.scores, data.winnerID));
	      });
	      return games;
	    }
	  }, {
	    key: 'pushLocalStorage',
	    value: function pushLocalStorage() {
	      window.localStorage.setItem('yaniv-score-games', (0, _stringify2.default)(this.state.games));
	    }
	  }]);
	  return GamesStore;
	}();
	
	exports.default = new GamesStore();

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(18);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayersStore = function () {
	  function PlayersStore() {
	    (0, _classCallCheck3.default)(this, PlayersStore);
	
	    this.state = {
	      players: this.getLocalStorage()
	    };
	    this.$colors = ['#00BCD4', '#F50057', '#4CAF50', '#7E57C2', '#CDDC39', '#8BC34A', '#009688', '#FF5722', '#607D8B'];
	  }
	
	  (0, _createClass3.default)(PlayersStore, [{
	    key: 'addPlayer',
	    value: function addPlayer(name) {
	      var color = this.$colors[this.state.players.length % this.$colors.length];
	      this.state.players.push({
	        color: color,
	        name: name,
	        enable: true
	      });
	    }
	  }, {
	    key: 'removePlayer',
	    value: function removePlayer(playerIndex) {
	      this.state.players.splice(playerIndex, 1);
	    }
	  }, {
	    key: 'getLocalStorage',
	    value: function getLocalStorage() {
	      var storedPlayers = window.localStorage['yaniv-score-users'];
	      return storedPlayers ? JSON.parse(storedPlayers) : [];
	    }
	  }, {
	    key: 'pushLocalStorage',
	    value: function pushLocalStorage() {
	      window.localStorage.setItem('yaniv-score-users', (0, _stringify2.default)(this.state.players));
	    }
	  }]);
	  return PlayersStore;
	}();
	
	exports.default = new PlayersStore();

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(46)
	
	/* template */
	var __vue_template__ = __webpack_require__(114)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(86)
	
	/* script */
	__vue_exports__ = __webpack_require__(47)
	
	/* template */
	var __vue_template__ = __webpack_require__(112)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayersStore = __webpack_require__(17);
	
	var _PlayersStore2 = _interopRequireDefault(_PlayersStore);
	
	var _GamesStore = __webpack_require__(3);
	
	var _GamesStore2 = _interopRequireDefault(_GamesStore);
	
	var _MainNav = __webpack_require__(101);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	var _Install = __webpack_require__(99);
	
	var _Install2 = _interopRequireDefault(_Install);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    'main-nav': _MainNav2.default,
	    'install': _Install2.default
	  },
	  data: function data() {
	    return {
	      playersState: _PlayersStore2.default.state,
	      gamesState: _GamesStore2.default.state,
	      bannerEnabled: false
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    this.deferredPrompt = null;
	    window.addEventListener('beforeinstallprompt', function (e) {
	      e.preventDefault();
	      _this.deferredPrompt = e;
	      _this.bannerEnabled = true;
	    });
	  },
	
	  methods: {
	    onCloseBanner: function onCloseBanner() {
	      this.bannerEnabled = false;
	    },
	    onInstallBanner: function onInstallBanner() {
	      var _this2 = this;
	
	      this.bannerEnabled = false;
	      if (!this.deferredPrompt) return;
	      this.deferredPrompt.prompt();
	      this.deferredPrompt.userChoice.then(function (choiceResult) {
	        if (choiceResult.outcome === 'accepted') {} else {}
	        _this2.deferredPrompt = null;
	      });
	    }
	  },
	  watch: {
	    playersState: {
	      handler: function handler(value) {
	        _PlayersStore2.default.pushLocalStorage();
	      },
	      deep: true
	    },
	    gamesState: {
	      handler: function handler(value) {
	        _GamesStore2.default.pushLocalStorage();
	      },
	      deep: true
	    }
	  }
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GamesStore = __webpack_require__(3);
	
	var _GamesStore2 = _interopRequireDefault(_GamesStore);
	
	var _Keyboard = __webpack_require__(100);
	
	var _Keyboard2 = _interopRequireDefault(_Keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      playerIndex: 0,
	      points: 0,
	      round: []
	    };
	  },
	  computed: {
	    game: function game() {
	      return _GamesStore2.default.state.currentGame;
	    },
	    player: function player() {
	      return this.game && this.game.players ? this.game.players[this.playerIndex] : null;
	    }
	  },
	  methods: {
	    onKeyboardPress: function onKeyboardPress(key) {
	      switch (key) {
	        case 'valid':
	          this.round.push(this.points);
	          this.playerIndex++;
	          this.points = 0;
	          if (this.playerIndex === this.game.players.length) {
	            this.game.addRound(this.round);
	            this.playerIndex = 0;
	            this.round = [];
	            _GamesStore2.default.pushLocalStorage();
	            this.$emit('onPopState');
	          }
	          break;
	        case 'erase':
	          this.points = Math.floor(this.points * 0.1);
	          break;
	        default:
	          if (this.points === 0) {
	            this.points = key;
	          } else if (this.points < 10) {
	            this.points = this.points * 10 + key;
	          }
	      }
	    }
	  },
	  components: {
	    'keyboard': _Keyboard2.default
	  }
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GamesStore = __webpack_require__(3);
	
	var _GamesStore2 = _interopRequireDefault(_GamesStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  filters: {
	    scorePercent: function scorePercent(score) {
	      return Math.round(score / _GamesStore.SCORE_MAX * 100);
	    }
	  },
	  data: function data() {
	    var _this = this;
	
	    return {
	      header: {
	        rightIcon: 'icon-replay',
	        rightAction: function rightAction() {
	          var answer = confirm('Annuler le dernier coup ?');
	          if (answer) {
	            _this.cancelRound();
	            return true;
	          }
	          return false;
	        }
	      },
	      scoreMax: _GamesStore.SCORE_MAX
	    };
	  },
	
	  computed: {
	    game: function game() {
	      return _GamesStore2.default.state.currentGame;
	    },
	    scores: function scores() {
	      return this.game ? this.game.scores : null;
	    },
	    currentScores: function currentScores() {
	      return this.game && this.game.scores ? this.game.scores[this.game.scores.length - 1] : 0;
	    },
	    gameOver: function gameOver() {
	      return _GamesStore2.default.state.currentGame.winnerID >= 0;
	    }
	  },
	  methods: {
	    editScore: function editScore(index) {
	      this.game.setYanivID(index);
	      this.$emit('onPushState', 'edit-score');
	    },
	    cancelRound: function cancelRound() {
	      this.game.removeLastRound();
	    },
	    getScorePercent: function getScorePercent(score) {
	      return Math.round(score / _GamesStore.SCORE_MAX * 100);
	    }
	  }
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableCell = __webpack_require__(33);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GameCell',
	  mixins: [_TableCell2.default]
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GamesStore = __webpack_require__(3);
	
	var _GamesStore2 = _interopRequireDefault(_GamesStore);
	
	var _TableData = __webpack_require__(34);
	
	var _TableData2 = _interopRequireDefault(_TableData);
	
	var _GameCell = __webpack_require__(97);
	
	var _GameCell2 = _interopRequireDefault(_GameCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TableData: _TableData2.default,
	    GameCell: _GameCell2.default
	  },
	  data: function data() {
	    return {
	      games: _GamesStore2.default.state.games
	    };
	  },
	
	  methods: {
	    startGame: function startGame() {
	      var twoDigits = function twoDigits(x) {
	        return x < 10 ? '0' + x : '' + x;
	      };
	      var today = new Date();
	      var dd = twoDigits(today.getDate());
	      var mm = twoDigits(today.getMonth());
	      var yyyy = today.getFullYear();
	      var h = twoDigits(today.getHours());
	      var m = twoDigits(today.getMinutes());
	      var name = dd + '/' + mm + '/' + yyyy + ' - ' + h + ':' + m;
	      var gameID = _GamesStore2.default.addGame(name);
	      _GamesStore2.default.setCurrentGame(gameID);
	      this.$emit('onPushState', 'player-list', false);
	    },
	    selectGame: function selectGame(gameID) {
	      _GamesStore2.default.setCurrentGame(gameID);
	      if (_GamesStore2.default.state.currentGame.hasPlayers()) {
	        this.$emit('onPushState', 'game');
	      } else {
	        this.$emit('onPushState', 'player-list', false);
	      }
	    },
	    removeGame: function removeGame(gameID) {
	      var response = confirm('Voulez vous vraiment supprimer cette partie ?');
	      if (response) {
	        setTimeout(function () {
	          return _GamesStore2.default.removeGame(gameID);
	        }, 500);
	      }
	    }
	  }
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'install',
	  methods: {
	    onInstall: function onInstall() {
	      this.$emit('install');
	    },
	    onClose: function onClose() {
	      this.$emit('close');
	    }
	  }
	};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    methods: {
	        keyPress: function keyPress(value) {
	            this.$emit('keyboardPress', value);
	        }
	    }
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navigation = __webpack_require__(104);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _PlayerList = __webpack_require__(103);
	
	var _PlayerList2 = _interopRequireDefault(_PlayerList);
	
	var _Game = __webpack_require__(96);
	
	var _Game2 = _interopRequireDefault(_Game);
	
	var _GameList = __webpack_require__(98);
	
	var _GameList2 = _interopRequireDefault(_GameList);
	
	var _EditScore = __webpack_require__(95);
	
	var _EditScore2 = _interopRequireDefault(_EditScore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_Navigation2.default],
	  components: {
	    'game-list': _GameList2.default,
	    'player-list': _PlayerList2.default,
	    'game': _Game2.default,
	    'edit-score': _EditScore2.default
	  },
	  data: function data() {
	    return {
	      rightIcon: null,
	      rightAction: function rightAction() {}
	    };
	  },
	  mounted: function mounted() {
	    this.onPushState('game-list');
	  },
	
	  watch: {
	    state: function state() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        var header = _this.$children[0] ? _this.$children[0].$data.header || {} : {};
	        _this.rightIcon = header.rightIcon;
	        _this.rightAction = header.rightAction;
	      });
	    }
	  }
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TableCell = __webpack_require__(33);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PlayerCell',
	  mixins: [_TableCell2.default]
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PlayersStore = __webpack_require__(17);
	
	var _PlayersStore2 = _interopRequireDefault(_PlayersStore);
	
	var _GamesStore = __webpack_require__(3);
	
	var _GamesStore2 = _interopRequireDefault(_GamesStore);
	
	var _TableData = __webpack_require__(34);
	
	var _TableData2 = _interopRequireDefault(_TableData);
	
	var _PlayerCell = __webpack_require__(102);
	
	var _PlayerCell2 = _interopRequireDefault(_PlayerCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    TableData: _TableData2.default,
	    PlayerCell: _PlayerCell2.default
	  },
	  data: function data() {
	    return {
	      name: '',
	      playerState: _PlayersStore2.default.state
	    };
	  },
	
	  computed: {
	    players: function players() {
	      return this.playerState.players;
	    },
	    playersInGame: function playersInGame() {
	      return this.players.filter(function (player) {
	        return player.enable;
	      });
	    }
	  },
	  methods: {
	    getPlayerGameCount: function getPlayerGameCount(playerIndex) {
	      var player = this.players[playerIndex];
	      var games = _GamesStore2.default.state.games;
	      var isPlayer = function isPlayer(p) {
	        return player.name === p.name;
	      };
	      var isPlayerInGame = function isPlayerInGame(game) {
	        return game.players.some(isPlayer);
	      };
	      var playerGames = games.filter(isPlayerInGame);
	      return playerGames.length;
	    },
	    addPlayer: function addPlayer() {
	      _PlayersStore2.default.addPlayer(this.name);
	      _PlayersStore2.default.pushLocalStorage();
	      this.name = '';
	    },
	    removePlayer: function removePlayer(playerIndex) {
	      var playerGamesCount = this.getPlayerGameCount(playerIndex);
	      var name = _PlayersStore2.default.state.players[playerIndex].name;
	      var isConfirmed = confirm('Voulez vous vraiment supprimer le joueur ' + name + ' ?');
	      if (!isConfirmed) return;
	      if (playerGamesCount) {
	        var message = 'Attention ce joueur est pr\xE9sent dans ' + playerGamesCount + ' ' + (playerGamesCount > 1 ? 'parties' : 'partie') + '.';
	        isConfirmed = confirm(message);
	        if (!isConfirmed) return;
	      }
	      setTimeout(function () {
	        return _PlayersStore2.default.removePlayer(playerIndex);
	      }, 500);
	    },
	    startGame: function startGame() {
	      _GamesStore2.default.state.currentGame.setPlayers(this.playersInGame);
	      this.$emit('onPushState', 'game');
	    },
	    onPlayerSubmit: function onPlayerSubmit() {
	      this.$refs.inputPlayer.blur();
	    }
	  },
	  watch: {
	    name: function name(value) {
	      if (value) this.addPlayer();
	    }
	  }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      states: [],
	      statesKeep: true,
	      hasBeenPushed: true
	    };
	  },
	
	  computed: {
	    state: function state() {
	      return this.states[0];
	    }
	  },
	  methods: {
	    previous: function previous() {
	      this.onPopState();
	    },
	    onPushState: function onPushState(state) {
	      var keep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      if (!this.statesKeep) {
	        this.states.shift();
	      }
	      this.statesKeep = keep;
	      this.hasBeenPushed = true;
	      this.states.unshift(state);
	    },
	    onPopState: function onPopState() {
	      this.statesKeep = true;
	      this.hasBeenPushed = false;
	      this.states.shift();
	    }
	  }
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'TableCell',
	  props: {
	    cellData: { type: Object, default: null },
	    cellIndex: { type: Number, default: -1 }
	  }
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'TableData',
	  props: {
	    items: { type: Array, default: null },
	    removable: { type: Boolean, default: true }
	  },
	  data: function data() {
	    return {
	      dragValue: { x: 0, y: 0 },
	      dragItemIndex: -1
	    };
	  },
	
	  methods: {
	    getItemIndex: function getItemIndex(target) {
	      var selected = target;
	      while (selected.parentNode && selected.parentNode !== this.$el) {
	        selected = selected.parentNode;
	      }
	      return Array.prototype.indexOf.call(this.$el.childNodes, selected);
	    },
	    getDragFromEvent: function getDragFromEvent(e) {
	      return {
	        x: e.touches ? e.touches[0].clientX : e.clientX,
	        y: e.touches ? e.touches[0].clientY : e.clientY
	      };
	    },
	    startDrag: function startDrag(e) {
	      var index = this.getItemIndex(e.target);
	      this.dragItemIndex = index;
	      this.dragOrigin = this.getDragFromEvent(e);
	      switch (e.type) {
	        case 'mousedown':
	          window.addEventListener('mousemove', this.dragging);
	          window.addEventListener('mouseup', this.stopDrag);
	          break;
	        case 'touchstart':
	          window.addEventListener('touchmove', this.dragging);
	          window.addEventListener('touchend', this.stopDrag);
	          break;
	      }
	    },
	    dragging: function dragging(e) {
	      this.dragValue = {
	        x: Math.max(this.dragOrigin.x - this.getDragFromEvent(e).x, 0),
	        y: this.dragOrigin.y - this.getDragFromEvent(e).y
	      };
	    },
	    stopDrag: function stopDrag() {
	      window.removeEventListener('mousemove', this.dragging);
	      window.removeEventListener('mouseup', this.stopDrag);
	      window.removeEventListener('touchmove', this.dragging);
	      window.removeEventListener('touchend', this.stopDrag);
	      if (this.dragItemIndex > -1) {
	        if (this.dragValue.x < 25 && Math.abs(this.dragValue.y) < 25) {
	          this.$emit('select', this.dragItemIndex);
	        }
	        if (this.dragValue.x > 100) {
	          this.$emit('remove', this.dragItemIndex);
	        }
	      }
	      this.dragValue = { x: 0, y: 0 }, this.dragItemIndex = -1;
	    }
	  }
	};

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(83)
	
	/* script */
	__vue_exports__ = __webpack_require__(35)
	
	/* template */
	var __vue_template__ = __webpack_require__(109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(80)
	
	/* script */
	__vue_exports__ = __webpack_require__(36)
	
	/* template */
	var __vue_template__ = __webpack_require__(106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(87)
	
	/* script */
	__vue_exports__ = __webpack_require__(37)
	
	/* template */
	var __vue_template__ = __webpack_require__(113)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(88)
	
	/* script */
	__vue_exports__ = __webpack_require__(38)
	
	/* template */
	var __vue_template__ = __webpack_require__(115)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(84)
	
	/* script */
	__vue_exports__ = __webpack_require__(39)
	
	/* template */
	var __vue_template__ = __webpack_require__(110)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(85)
	
	/* script */
	__vue_exports__ = __webpack_require__(40)
	
	/* template */
	var __vue_template__ = __webpack_require__(111)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(79)
	
	/* script */
	__vue_exports__ = __webpack_require__(41)
	
	/* template */
	var __vue_template__ = __webpack_require__(105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(81)
	
	/* script */
	__vue_exports__ = __webpack_require__(42)
	
	/* template */
	var __vue_template__ = __webpack_require__(107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(82)
	
	/* script */
	__vue_exports__ = __webpack_require__(43)
	
	/* template */
	var __vue_template__ = __webpack_require__(108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(89)
	
	/* script */
	__vue_exports__ = __webpack_require__(44)
	
	/* template */
	var __vue_template__ = __webpack_require__(116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(90)
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(117)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "keyboard-template"
	  }, [_c('div', {
	    staticClass: "digits"
	  }, [_vm._l((12), function(n) {
	    return [(n <= 9) ? _c('button', {
	      staticClass: "digit fab",
	      on: {
	        "click": function($event) {
	          _vm.keyPress(n)
	        }
	      }
	    }, [_vm._v(_vm._s(n))]) : _vm._e(), _vm._v(" "), (n === 10) ? _c('button', {
	      staticClass: "digit fab",
	      on: {
	        "click": function($event) {
	          _vm.keyPress('erase')
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-backspace"
	    })]) : _vm._e(), _vm._v(" "), (n === 11) ? _c('button', {
	      staticClass: "digit fab",
	      on: {
	        "click": function($event) {
	          _vm.keyPress(0)
	        }
	      }
	    }, [_vm._v("0")]) : _vm._e(), _vm._v(" "), (n === 12) ? _c('button', {
	      staticClass: "digit fab",
	      on: {
	        "click": function($event) {
	          _vm.keyPress('valid')
	        }
	      }
	    }, [_c('i', {
	      staticClass: "icon-check"
	    })]) : _vm._e()]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "edit-score-template"
	  }, [(_vm.player) ? _c('div', {
	    staticClass: "player-score",
	    style: ({
	      'color': _vm.player.color
	    })
	  }, [_c('div', {
	    staticClass: "player"
	  }, [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('div', {
	    staticClass: "point"
	  }, [_vm._v(_vm._s(_vm.points))])]) : _vm._e(), _vm._v(" "), _c('keyboard', {
	    on: {
	      "keyboardPress": _vm.onKeyboardPress
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "navigation",
	    class: {
	      'backward': !_vm.hasBeenPushed,
	      'forward': _vm.hasBeenPushed
	    }
	  }, [_c('div', {
	    staticClass: "toolbar bg-blue-400 color-white"
	  }, [_c('button', {
	    staticClass: "icon-button",
	    class: {
	      'hide': _vm.states.length <= 1
	    },
	    on: {
	      "click": function($event) {
	        _vm.previous()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-arrow-back"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "toolbar-label"
	  }, [_vm._v("Yaniv Scores")]), _vm._v(" "), (_vm.rightIcon && _vm.rightAction) ? _c('span', {
	    staticClass: "float-right"
	  }, [_c('button', {
	    staticClass: "icon-button",
	    on: {
	      "click": function($event) {
	        _vm.rightAction()
	      }
	    }
	  }, [_c('i', {
	    class: _vm.rightIcon
	  })])]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "view-transition"
	    }
	  }, [_c(_vm.state, {
	    key: "state",
	    tag: "component",
	    staticClass: "view",
	    on: {
	      "onPushState": _vm.onPushState,
	      "onPopState": _vm.onPopState
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "player-cell"
	  }, [_c('div', {
	    staticClass: "player-puce",
	    style: ({
	      'background-color': _vm.cellData.color
	    })
	  }), _vm._v(" "), _c('p', {
	    staticClass: "player-name"
	  }, [_vm._v(_vm._s(_vm.cellData.name))]), _vm._v(" "), _c('div', {
	    staticClass: "player-enable switch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cellData.enable),
	      expression: "cellData.enable"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": 'player#' + _vm.cellIndex
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.cellData.enable) ? _vm._i(_vm.cellData.enable, null) > -1 : (_vm.cellData.enable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.cellData.enable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.cellData, "enable", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.cellData, "enable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.cellData, "enable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": 'player#' + _vm.cellIndex
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bg-grey-200",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    staticClass: "main-container"
	  }, [_c('main-nav'), _vm._v(" "), (_vm.bannerEnabled) ? _c('install', {
	    on: {
	      "install": _vm.onInstallBanner,
	      "close": _vm.onCloseBanner
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "gamelist-template"
	  }, [_c('table-data', {
	    staticClass: "games",
	    attrs: {
	      "items": _vm.games
	    },
	    on: {
	      "select": _vm.selectGame,
	      "remove": _vm.removeGame
	    },
	    scopedSlots: _vm._u([{
	      key: "item",
	      fn: function(props) {
	        return _c('game-cell', {
	          attrs: {
	            "cell-data": props.itemdata,
	            "cell-index": props.itemindex
	          }
	        })
	      }
	    }])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button color-blue-500 start-button",
	    on: {
	      "click": function($event) {
	        _vm.startGame()
	      }
	    }
	  }, [_vm._v("Nouvelle partie")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "install",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.onInstall($event)
	      }
	    }
	  }, [_c('img', {
	    staticClass: "install_picto",
	    attrs: {
	      "src": "favicon-32x32.png"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "install_label color-blue-500"
	  }, [_vm._v("Installer l'application Yaniv Scores ?")]), _vm._v(" "), _c('div', {
	    staticClass: "install_close",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.onClose($event)
	      }
	    }
	  }, [_vm._v("✕")])])
	},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "table-data",
	    on: {
	      "mousedown": _vm.startDrag,
	      "touchstart": _vm.startDrag
	    }
	  }, _vm._l((_vm.items), function(data, index) {
	    return _c('li', {
	      key: index,
	      class: [
	        'table-data-item',
	        {
	          'table-data-item--dragging': _vm.dragItemIndex === index
	        } ],
	      style: ({
	        'transform': ("translate3d(" + (_vm.removable && _vm.dragItemIndex === index ? -_vm.dragValue.x : 0) + "px, 0, 0)")
	      })
	    }, [_vm._t("item", [_vm._v("\n      " + _vm._s(data.label || data.name) + "\n    ")], {
	      itemdata: data,
	      itemindex: index
	    })], 2)
	  }))
	},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "game-template"
	  }, [(_vm.game) ? _c('ul', {
	    staticClass: "players"
	  }, _vm._l((_vm.game.players), function(player, playerID) {
	    return _c('li', {
	      staticClass: "player"
	    }, [_c('div', {
	      staticClass: "player-stats",
	      class: {
	        'player-stats--gameover': _vm.gameOver
	      }
	    }, [_c('div', {
	      staticClass: "player-stats-top"
	    }, [_c('p', {
	      staticClass: "player-name"
	    }, [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('p', {
	      staticClass: "player-score",
	      style: ({
	        'color': player.color
	      })
	    }, [_vm._v("\n            " + _vm._s(_vm.currentScores && _vm.currentScores[playerID] ? _vm.currentScores[playerID].total : 0) + "\n          ")])]), _vm._v(" "), _c('div', {
	      staticClass: "score-progress",
	      style: ({
	        'background-color': player.color,
	        'width': _vm.getScorePercent(_vm.currentScores && _vm.currentScores[playerID] ? _vm.currentScores[playerID].total : 0) + '%'
	      })
	    }), _vm._v(" "), _c('div', {
	      staticClass: "player-stats-bottom"
	    }, _vm._l((_vm.game.rounds), function(round, id) {
	      return (_vm.game.rounds) ? _c('p', {
	        staticClass: "player-score-previous",
	        class: {
	          'player-score-previous--yaniv': _vm.scores[id][playerID].yaniv && !_vm.scores[id][playerID].contre,
	            'player-score-previous--contre': _vm.scores[id][playerID].contre,
	            'player-score-previous--douche': _vm.scores[id][playerID].douche
	        }
	      }, [_c('span', {
	        staticClass: "player-score-previous_point",
	        style: (_vm.scores[id][playerID].yaniv && !_vm.scores[id][playerID].contre ? {
	          'background-color': player.color
	        } : {})
	      }, [_vm._v("\n              " + _vm._s(round[playerID]) + "\n            ")]), _vm._v(" "), _c('span', {
	        staticClass: "player-score-previous_score",
	        style: ({
	          'color': player.color,
	          'text-decoration': 'none'
	        })
	      }, [_vm._v("\n              " + _vm._s(_vm.scores[id][playerID].total) + "\n            ")])]) : _vm._e()
	    }))]), _vm._v(" "), _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.gameOver),
	        expression: "!gameOver"
	      }],
	      staticClass: "button-yaniv ripple circle",
	      style: ({
	        'background-color': player.color
	      }),
	      on: {
	        "click": function($event) {
	          _vm.editScore(playerID)
	        }
	      }
	    }, [_vm._v("YANIV!")])])
	  })) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-cell"
	  }, [_vm._t("default", [_c('p', {
	    staticClass: "table-cell-name"
	  }, [_vm._v(_vm._s(_vm.cellData.label || _vm.cellData.name))])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "game-cell"
	  }, [_c('p', {
	    staticClass: "game-name"
	  }, [_vm._v(_vm._s(_vm.cellData.name))]), _vm._v(" "), _c('p', {
	    staticClass: "game-players"
	  }, _vm._l((_vm.cellData.players), function(player, indexPlayer) {
	    return _c('span', {
	      class: {
	        'winner': indexPlayer === _vm.cellData.winnerID
	      }
	    }, [_vm._v(_vm._s(player.name))])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "players-template"
	  }, [_c('table-data', {
	    staticClass: "players",
	    attrs: {
	      "items": _vm.players
	    },
	    on: {
	      "remove": _vm.removePlayer
	    },
	    scopedSlots: _vm._u([{
	      key: "item",
	      fn: function(props) {
	        return _c('player-cell', {
	          attrs: {
	            "cell-data": props.itemdata,
	            "cell-index": props.itemindex
	          }
	        })
	      }
	    }])
	  }), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.onPlayerSubmit($event)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.name),
	      expression: "name",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    ref: "inputPlayer",
	    staticClass: "new-player-name text-input",
	    attrs: {
	      "type": "text",
	      "placeholder": "Ajouter un joueur"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "change": function($event) {
	        _vm.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "button color-blue-500 start-button",
	    attrs: {
	      "disabled": _vm.playersInGame.length < 2
	    },
	    on: {
	      "click": function($event) {
	        _vm.startGame()
	      }
	    }
	  }, [_vm._v("Nouvelle partie")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "navigation"
	  })
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.372628b99100db9686b9.js